import { saveAs } from 'file-saver';

export class FileSaver {
  public static saveFile(value) {
    saveAs(value);
  }
}
